import { BoxContainer, Text } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { uiConfig } from '../../../services/config';

export function ErrorBox(): JSX.Element {
  const { t } = useTranslation();

  return (
    <BoxContainer>
      <div>
        <Text
          style={{
            fontSize: '21px',
            color: '#0000006d',
            fontWeight: uiConfig.styles.fontWeights.bold,
          }}
        >
          {t('pickerError.title')}
        </Text>
        <div style={{ paddingTop: '10px' }}>
          <Text style={{ fontSize: '16px', color: '#0000006d' }}>
            {t('pickerError.description')}
          </Text>
        </div>
      </div>
    </BoxContainer>
  );
}
